import React from "react";
import { Facebook, Twitter, MessageCircle, Send as Telegram } from "lucide-react";

/**
 * SharePostCard (Iter-237) — the 4 canonical share targets required by the
 * legacy screenshots: WhatsApp, Facebook, Telegram, X. Each button opens
 * the platform's own share endpoint in a new tab. No backend calls —
 * everything is a client-side URL open.
 */
export default function SharePostCard({ url, title }) {
  const canonical =
    url || (typeof window !== "undefined" ? window.location.href : "");
  const t = title || "Check out this listing";
  const targets = [
    {
      key: "whatsapp",
      label: "WhatsApp",
      color: "var(--whatsapp)",
      Icon: MessageCircle,
      url: `https://wa.me/?text=${encodeURIComponent(`${t} ${canonical}`)}`,
    },
    {
      key: "facebook",
      label: "Facebook",
      color: "#1877F2",
      Icon: Facebook,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(canonical)}`,
    },
    {
      key: "telegram",
      label: "Telegram",
      color: "#0088CC",
      Icon: Telegram,
      url: `https://t.me/share/url?url=${encodeURIComponent(canonical)}&text=${encodeURIComponent(t)}`,
    },
    {
      key: "x",
      label: "X",
      color: "#0F172A",
      Icon: Twitter,
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(canonical)}&text=${encodeURIComponent(t)}`,
    },
  ];

  return (
    <section
      data-testid="share-post-card"
      className="rounded-3xl bg-white shadow-card p-6"
    >
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 mb-1">
        Share Post
      </div>
      <div className="text-slate-800 font-display text-lg font-semibold">
        Share this listing
      </div>
      <div className="text-xs text-slate-500 mt-0.5">
        Send it to a friend on the platform of your choice.
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-3">
        {targets.map(({ key, label, color, Icon, url: t2 }) => (
          // eslint-disable-next-line react/jsx-no-target-blank -- Social share endpoints often deep-link back — keep referrer.
          <a
            key={key}
            href={t2}
            target="_blank"
            rel="noopener"
            data-testid={`share-post-${key}`}
            aria-label={`Share on ${label}`}
            className="w-11 h-11 rounded-full grid place-items-center text-white hover:brightness-110 transition-all shadow-sm"
            style={{ backgroundColor: color }}
          >
            <Icon className="w-5 h-5" />
          </a>
        ))}
      </div>
    </section>
  );
}
